module.exports = __webpack_public_path__ + "static/media/mobile-hero-home.9ff6cfb3.jpg";